import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Sidebar = () => {
  const location = useLocation();

  const menuItems = [
    {
      path: '/',
      label: 'Admin Dashboard',
      iconClass: 'fa-solid fa-gauge',
    },
    {
      path: '/admin/files',
      label: 'File Management',
      iconClass: 'fa-regular fa-folder-open',
    },
    {
      path: '/admin/requiries',
      label: 'Requiries',
      iconClass: 'fa-regular fa-envelope',
    },
    {
      path: '/admin/users',
      label: 'Users',
      iconClass: 'fa-solid fa-users',
    },
  ];

  const allMenuItems = menuItems;

  return (
    <aside style={{
      width: '250px',
      backgroundColor: 'var(--bg-secondary)',
      borderRight: '1px solid var(--border-color)',
      padding: '1rem 0',
      overflowY: 'auto',
    }}>
      <nav>
        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
          {allMenuItems.map((item) => (
            <li key={item.path}>
              <Link
                to={item.path}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '1rem 1.5rem',
                  textDecoration: 'none',
                  color: location.pathname === item.path ? 'var(--orange-dark)' : 'var(--text-secondary)',
                  backgroundColor: location.pathname === item.path ? 'rgba(255, 165, 0, 0.1)' : 'transparent',
                  borderRight: location.pathname === item.path ? '3px solid var(--orange-dark)' : 'none',
                  fontWeight: location.pathname === item.path ? '600' : '400',
                  transition: 'var(--transition)',
                }}
              >
                <span style={{
                  marginRight: '0.75rem',
                  fontSize: '1.2rem',
                  width: '1.2rem',
                  display: 'inline-flex',
                  justifyContent: 'center'
                }}>
                  <i className={item.iconClass} aria-hidden="true"></i>
                </span>
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </aside>
  );
};

export default Sidebar;
